import { render } from "./StatusStepItem.vue?vue&type=template&id=07dea6a4&scoped=true"
import script from "./StatusStepItem.vue?vue&type=script&lang=js"
export * from "./StatusStepItem.vue?vue&type=script&lang=js"

import "./StatusStepItem.vue?vue&type=style&index=0&id=07dea6a4&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dea6a4"]])

export default __exports__